import { render } from "./eye_imaging.vue?vue&type=template&id=6da8d7ed&scoped=true"
import script from "./eye_imaging.vue?vue&type=script&lang=js"
export * from "./eye_imaging.vue?vue&type=script&lang=js"

import "./eye_imaging.vue?vue&type=style&index=0&id=6da8d7ed&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da8d7ed"]])

export default __exports__